import { Answers } from "./types";

export const yesNoDontKnow = [
  { text: "Ja", value: 1 },
  { text: "Nej", value: 0 },
  { text: "Vet ej", value: 2 },
];

export const calculateRiskOfHypertension = (
  answers?: Answers
): "low" | "high" => {
  const bmiRiskThreshold = 30;
  const probabilityRelevantAnswers = [
    answers?.q3,
    answers?.q4,
    answers?.q12,
    answers?.q32,
  ];
  const bmi = answers?.q6;
  const isFiftyOrOlder = answers?.q2 === 2;
  const hasHeridityRisk = isFiftyOrOlder && answers?.q13 === 1;

  if (
    bmi &&
    Number(bmi) < bmiRiskThreshold &&
    probabilityRelevantAnswers.every((a) => !a) &&
    !hasHeridityRisk
  ) {
    return "low";
  }

  return "high";
};
